export function dedupeTagsFromProducts(products) {
  const byId = new Map();

  (products ?? []).forEach((product) => {
    (product.tags ?? []).forEach((tag) => byId.set(tag.id, tag));
  });

  return [...byId.values()].sort((a, b) => a.name.localeCompare(b.name));
}
